export default __webpack_public_path__ + "static/media/icon.hemostatic-gauzes.e61b32c0.svg";